import {
    CANCEL_SUBSCRIPTION,
    CANCEL_SUBSCRIPTION_FEEDBACK,
    CANCEL_SUBSCRIPTION_CONFIRMATION,
    INVOICES,
    INVOICE_DETAILS,
    CONFIRMATION_MODAL,
} from '../../src/client/modal/types';
import { formatUIImpressionEventParams } from '../../src/client/util/tracking';
import { formatFormEventParamsLegacy } from '../../src/client/util/trackingLegacy';
import {
    CANCEL_PTR,
    CANCEL_ADDON,
    REACTIVATE_PTR,
    REACTIVATE_SUBSCRIPTION,
    QUIT_SHARING,
    DELETE_INVITE,
    SHARING_ACCEPT_SUCCESS,
    ACTION_REQUIRED,
    DELIVERY_DELETION,
} from '../../src/client/vNext/modal/types';

const modalEventsMap = {
    // Legacy Redux-based modals
    [CANCEL_SUBSCRIPTION]: 'terminate_subscription',
    [CANCEL_SUBSCRIPTION_FEEDBACK]: 'terminate_confirm_step1',
    [CANCEL_SUBSCRIPTION_CONFIRMATION]: 'terminate_confirm_step2',
    [INVOICES]: 'view_invoices_list',
    [INVOICE_DETAILS]: 'view_invoice_details',
    [CONFIRMATION_MODAL]: 'confirmation_dialog',
    // vNext context-based modals
    [REACTIVATE_SUBSCRIPTION]: 'confirmation_reactivate',
    [CANCEL_PTR]: 'cancel_ptr_modal',
    [CANCEL_ADDON]: 'cancel_addon_modal',
    [REACTIVATE_PTR]: 'reactivate_ptr_modal',
    [QUIT_SHARING]: 'quit_sharing_modal',
    [DELETE_INVITE]: 'delete_invite_modal',
    [SHARING_ACCEPT_SUCCESS]: 'sharing_accept_success_modal',
    [ACTION_REQUIRED]: 'action_required_modal',
    [DELIVERY_DELETION]: 'delivery_deletion_modal',
};

export const formatModalViewEventParams = ({ modalType }) =>
    formatUIImpressionEventParams({
        id: `open_${modalEventsMap[modalType]}`,
    });

export const formatModalCloseEventParams = ({ modalType }) =>
    formatUIImpressionEventParams({
        id: `close_${modalEventsMap[modalType]}`,
    });

export const formatModalViewEventParamsLegacy = ({ modalType }) =>
    formatFormEventParamsLegacy({
        type: 'View',
        id: modalEventsMap[modalType],
    });
export const formatModalCloseEventParamsLegacy = ({ modalType }) =>
    formatFormEventParamsLegacy({
        type: 'Close',
        id: modalEventsMap[modalType],
    });
